import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import People from "@material-ui/icons/People";
import List from "@material-ui/icons/List";
import DescriptionIcon from "@material-ui/icons/Description";
import BusinessIcon from "@material-ui/icons/Business";
import LanguageIcon from "@material-ui/icons/Language";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ReceiptIcon from "@material-ui/icons//Receipt";
import ViewAgendaIcon from "@material-ui/icons/ViewAgenda";
import FormatAlignJustifyIcon from "@material-ui/icons/FormatAlignJustify";
import WorkIcon from "@material-ui/icons/Work";
import APIModel from "../../Models/APIModel";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const sideRef = React.useRef(null);
  const history = useHistory();
  let location = useLocation();
  const url = location.pathname.split("/")[1];
  let user_id = localStorage.getItem("user_id");
  const [weburl, setHost] = useState(APIModel.URL);
  function logout() {
    localStorage.clear("token");
    history.push("/");
  }

  useEffect(() => {
   
    const handleClickOutside = (e) => {
      if (sideRef.current && !sideRef.current.contains(e.target)) {
       //setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); 

  return (
    <div
      ref={sideRef}
      className={isOpen ? "sidebar active" : "sidebar"}
      data-color="purple"
      data-background-color="white"
      data-image="../assets/img/sidebar-1.jpg"
    >
      <div className="logo">
        <img
          src={process.env.PUBLIC_URL + "/logo.png"}
          alt="Logo"
          className="logo"
          style={{ height: "100px" }}
        />
      </div>
      <div className="sidebar-wrapper">
        <ul className="nav mb-5">
          <li
            className={
              url === "admin-dashboard" ? "nav-item active" : "nav-item"
            }
          >
            <Link
              to="/admin-dashboard"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">dashboard</i>Dashboard
              </Box>
            </Link>
          </li>
          <li className={url === "estimates" ? "nav-item active" : "nav-item"}>
            <Link
              to="/estimates"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <DescriptionIcon />
                </i>
                Estimates
              </Box>
            </Link>
          </li>
          <li className={url === "invoices" ? "nav-item active" : "nav-item"}>
            <Link
              to="/invoices"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <ReceiptIcon />
                </i>
                Invoices
              </Box>
            </Link>
          </li>
          
          <li className={url === "addition-work-data" ? "nav-item active" : "nav-item"}>
            <Link
              to="/addition-work-data"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <FormatAlignJustifyIcon />
                </i>
                Additional Work Authorization
              </Box>
            </Link>
          </li>

         
          <li className={url === "forms" ? "nav-item active" : "nav-item"}>
            <Link
              to="/forms"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <FormatAlignJustifyIcon />
                </i>
                Forms
              </Box>
            </Link>
          </li>
          <li
            className={
              url === "send-lien-form-data" ? "nav-item active" : "nav-item"
            }
          >
            <Link
              to="/send-lien-form-data"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <ViewAgendaIcon />
                </i>
                Lien Form Data
              </Box>
            </Link>
          </li>
          {/* <li
            className={url === "contract-form" ? "nav-item active" : "nav-item"}
          >
            <Link to="/contract-form" className="nav-link">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <DescriptionIcon />
                </i>
                Lien Forms
              </Box>
            </Link>
          </li> */}
          {/* <li className={url === "all-taxes" ? "nav-item active" : "nav-item"}>
            <Link to="/all-taxes" className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <DescriptionIcon />
                </i>
                Taxes
              </Box>
            </Link>
          </li> */}
          <li className={url === "client" ? "nav-item active" : "nav-item"}>
            <Link
              to="/client"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <People />
                </i>
                Clients
              </Box>
            </Link>
          </li>
          <li className={url === "item" ? "nav-item active" : "nav-item"}>
            <Link
              to="/item"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <List />
                </i>
                Items
              </Box>
            </Link>
          </li>
          {/* <li className={url === "send-lien-form" ? "nav-item active" : "nav-item"}>
            <Link to="/send-lien-form" className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <List />
                </i>
                Send Lien Form
              </Box>
            </Link>
          </li> */}
          <li
            className={
              url === "company-detail" ? "nav-item active" : "nav-item"
            }
          >
            <Link
              to="/company-detail"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <BusinessIcon />
                </i>
                Company Detail
              </Box>
            </Link>
          </li>
          <li
            className={url === "web-and-links" ? "nav-item active" : "nav-item"}
          >
            <Link
              to="/web-and-links"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <LanguageIcon />
                </i>
                Web & Links
              </Box>
            </Link>
          </li>
          <li className={url === "setting" ? "nav-item active" : "nav-item"}>
            <Link
              to="/setting"
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <SettingsIcon />
                </i>
                Setting
              </Box>
            </Link>
          </li>
          <li className={url === "/" ? "nav-item active" : "nav-item"}>
            <Link
              className="nav-link navbar-toggler"
              aria-controls="navigation-index"
              aria-expanded="false"
              onClick={() => logout()}
            >
              <Box
                fontSize={16}
                fontWeight="fontWeightRegular"
                className="d-flex align-items-center"
              >
                <i className="material-icons">
                  <ExitToAppIcon />
                </i>
                LOGOUT
              </Box>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
